import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Form } from 'react-bootstrap';
import './CRUDSensors.css';
import { Server_URL } from "../config.js";

function EditSensor() {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  // console.log("Get into EditSensor() id:", id);

  useEffect(() => {
    axios
      .get(`${Server_URL}/get_sensor/${id}`)
      // .get(`http://localhost:3022/get_sensor/${id}`)
      // .get(`http://localhost:5000/get_sensor/${id}`)
      .then((res) => { setData(res.data); })
      .catch((err) => console.log(err));
  }, [id]);

  function handleSubmit(e) {
    e.preventDefault();
    axios
      .post(`${Server_URL}/edit_sensor/${id}`, data[0])
      // .post(`http://localhost:3022/edit_sensor/${id}`, data[0])
      // .post(`http://localhost:5000/edit_sensor/${id}`, data[0])
      .then((res) => { navigate(-1); })
      // .then((res) => { navigate("/CRUDSensors"); })
      // .then((res) => { navigate("/"); console.log(res); })
      .catch((err) => console.log(err));
  }

  return (
    <div className='vh-100 vw-100 bg-primary-subtle'>
      <Container className='container-fluid'>
        <Row>
          <div className='d-flex justify-content-center'> <h2>Edit Sensor SNo: {id}</h2> </div>
        </Row>
        <Row>
          <Col className='justify-content-start'>
            <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
          </Col>
        </Row>
      </Container>
      <Container className='container-fluid vh-80 vw-100 bg-primary-subtle'>
        {data.map((sensor, i) => {
          return (
            <Form onSubmit={handleSubmit} key={i++}>
              <Container>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="SNo"><b>SNo : </b></label>
                    <input value={sensor.SNo} required
                      type="number" onChange={(e) => setData([{ ...data[0], SNo: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="Size"><b>Size : </b></label>
                    <input value={sensor.Size} required
                      type='text25' onChange={(e) => setData([{ ...data[0], Size: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="PartNo"><b>PartNo : </b></label>
                    <input value={sensor.PartNo} required
                      type='text75' onChange={(e) => setData([{ ...data[0], PartNo: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="PartNo"><b>Ratio : </b></label>
                    <input value={sensor.Ratio}
                      type='text25' onChange={(e) => setData([{ ...data[0], Ratio: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorOD"><b>SensorOD : </b></label>
                    <input value={sensor.SensorOD}
                      type='text65' onChange={(e) => setData([{ ...data[0], SensorOD: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorAA"><b>SensorAA : </b></label>
                    <input value={sensor.SensorAA} required
                      type='text65' onChange={(e) => setData([{ ...data[0], SensorAA: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorThick"><b>SensorThick : </b></label>
                    <input value={sensor.SensorThick}
                      type='text50' onChange={(e) => setData([{ ...data[0], SensorThick: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="ChannelRxTx"><b>ChannelRxTx : </b></label>
                    <input value={sensor.ChannelRxTx}
                      type='text50' onChange={(e) => setData([{ ...data[0], ChannelRxTx: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="ControlCard"><b>ControlCard : </b></label>
                    <input value={sensor.ControlCard}
                      type='text50' onChange={(e) => setData([{ ...data[0], ControlCard: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="FpcLoc"><b>FpcLoc : </b></label>
                    <input value={sensor.FpcLoc}
                      type='text50' onChange={(e) => setData([{ ...data[0], FpcLoc: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="PrintPN"><b>PrintPN : </b></label>
                    <input value={sensor.PrintPN}
                      type='text50' onChange={(e) => setData([{ ...data[0], PrintPN: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="CustomerPN"><b>CustomerPN : </b></label>
                    <input value={sensor.CustomerPN}
                      type='text50' onChange={(e) => setData([{ ...data[0], CustomerPN: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-6'>
                    <label htmlFor="Note"><b>Note : </b></label>
                    <input value={sensor.Note}
                      type='text75' onChange={(e) => setData([{ ...data[0], Note: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-sm d-flex justify-content-start'>
                    <button type='submit' className='btn btn-success'>Save</button>
                  </Col>
                </Row>
              </Container>
            </Form>
          );
        })}
      </Container>
    </div >
  )
}

export default EditSensor;